import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

export function Input(inputProps: ComponentProps<'input'>) {
  const { className, type, ...props } = inputProps;
  return (
    <input
      type={type}
      data-slot={'input'}
      className={cn(
        'bg-input dark:bg-input/35 hover:bg-input-focus dark:hover:bg-input-focus/75 border-border-primary focus-visible:border-border-primary-focus outline-focus-ring aria-invalid:outline-focus-ring-destructive dark:aria-invalid:outline-focus-ring-destructive/50 aria-invalid:border-destructive/75 disabled:bg-input/60 h-10 rounded-md border px-2.5 py-1 text-base transition-colors file:h-6 file:text-sm file:font-medium focus-visible:outline-3 aria-invalid:outline-3 md:text-sm file:text-foreground placeholder:text-muted-foreground w-full min-w-0 file:inline-flex file:border-0 file:bg-transparent disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-60 [&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none [&::-webkit-search-results-button]:appearance-none [&::-webkit-search-results-decoration]:appearance-none',
        className
      )}
      {...props}
    />
  );
}
